export default __webpack_public_path__ + "img/catIcon332.b2b03b01.svg";